import type { SelectOption } from '@/shared/ui/form/select/helpers/types';

/**
 * 現在の年度を取得する
 *
 * 年度は4月始まり: 4月〜翌3月を1年度とする。
 * - 4月以降（month >= 4）: 当年
 * - 1〜3月（month < 4）: 前年
 */
export const getCurrentFiscalYear = (): number => {
  const now = new Date();
  const month = now.getMonth() + 1;
  return month >= 4 ? now.getFullYear() : now.getFullYear() - 1;
};

/** 年度オプションの最小年度 */
export const FISCAL_YEAR_MIN = 2023;
/** 年度オプションの最大年度を取得 */
export const getFiscalYearMax = (): number => getCurrentFiscalYear() + 1;

/**
 * 年度セレクター用のオプション配列を生成する
 *
 * @param minYear - 最小年度（デフォルト: 2023）
 * @param maxYear - 最大年度（デフォルト: 現年度 + 1）
 * @returns SelectOption[] - 降順でソートされた年度オプション
 */
export const getFiscalYearOptions = ({
  minYear = FISCAL_YEAR_MIN,
  maxYear = getFiscalYearMax(),
}: {
  minYear?: number;
  maxYear?: number;
} = {}): SelectOption[] => {
  const options: SelectOption[] = [];
  for (let year = maxYear; year >= minYear; year--) {
    options.push({
      label: `${year}年度`,
      value: year,
    });
  }
  return options;
};
